const mvSwiper = new Swiper('.mv-swiper', {
    // Optional parameters
    loop: true,
    effect: 'slide',
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
        delay: 4000,
    },
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });


  // TO TOP
function smooth_scroll() {
  $('#BackToTop').click(function () {
    var headerHight = 250;
    var speed = 500;
    var href = $(this).attr('href').split("#")[1]; // 修正点
    var target = $(href == "" ? 'html' : '#' + href);
    var position = target.offset().top - headerHight;

    $("html, body").animate({ scrollTop: position }, speed, "swing");
    
    return false;
  });
}

$(document).ready(function () {
  smooth_scroll();
});